import React, { Component } from 'react';

import {
  checkmarkCircleOutline,
  checkmarkDoneCircleOutline,
  alertCircleOutline,
  helpCircleOutline,
} from 'ionicons/icons';
import {
  withIonLifeCycle,
  IonContent,
  IonHeader,
  IonToolbar,
  IonTitle,
  IonButtons,
  IonBackButton,
  IonButton,
  IonIcon,
  IonGrid,
  IonRow,
  IonCol,
} from '@ionic/react';

import ReservationsService from '../../services/reservations';
import HeaderButtons from '../../components/HeaderButtons';

import '../../theme/container.css';
import './payment.css';

class ReservationPaymentEndPage extends Component {
  constructor(props) {
    super(props);

    this.state = {
      // confirmed, pending, canceled (pagamento annullato), expired, error
      outcome: undefined,
      reservationId: undefined,
    };
  }

  async ionViewWillEnter() {
    await this.setState({ outcome: undefined, reservationId: undefined });

    const searchParams = new URLSearchParams(this.props.location.search);
    const status = searchParams.get('status');
    const paypalOrderId = searchParams.get('token');

    try {
      if (this.props.loader?.current) this.props.loader.current.show();

      if (status === 'OK' && !!paypalOrderId) {
        const { data: response } = await ReservationsService.paymentCapture(paypalOrderId);
        const reservation = response?.data || response;

        await this.setState({
          outcome: reservation.status === 'confirmed' ? 'confirmed' : 'pending',
          reservationId: reservation.id,
        });
      } else if (status === 'KO') {
        await this.setState({ outcome: 'canceled', reservationId: await this.findReservationId() });
      } else {
        await this.setState({ outcome: 'error' });
      }
    } catch (error) {
      if (error.response?.status !== 401) console.error(error);

      // 409: la prenotazione è scaduta o è stata annullata
      await this.setState({ outcome: error.response?.status === 409 ? 'expired' : 'error' });
    } finally {
      if (this.props.loader?.current) this.props.loader.current.dismiss();
    }
  }

  // Il ritorno da PayPal con KO non porta l'id della prenotazione: si ricava dall'ultima in attesa di pagamento
  async findReservationId() {
    try {
      const { data } = await ReservationsService.all();
      const reservations = data?.data || data || [];
      const awaitingPayment = reservations.filter((reservation) => reservation.status === 'awaiting_payment');

      return awaitingPayment.length ? awaitingPayment[awaitingPayment.length - 1].id : undefined;
    } catch (error) {
      console.error(error);

      return undefined;
    }
  }

  renderOutcome() {
    switch (this.state.outcome) {
      case 'confirmed':
        return (
          <>
            <IonIcon style={{ fontSize: '80px' }} color="success" icon={checkmarkDoneCircleOutline}></IonIcon>
            <h1>Prenotazione confermata</h1>
            <p>Il pagamento dell'acconto è andato a buon fine. Riceverai una conferma della prenotazione.</p>
          </>
        );

      case 'pending':
        return (
          <>
            <IonIcon style={{ fontSize: '80px' }} color="success" icon={checkmarkCircleOutline}></IonIcon>
            <h1>In attesa di conferma dalla farmacia</h1>
            <p>Il pagamento dell'acconto è andato a buon fine. La farmacia confermerà la prenotazione al più presto.</p>
          </>
        );

      case 'canceled':
        return (
          <>
            <IonIcon style={{ fontSize: '80px' }} color="danger" icon={alertCircleOutline}></IonIcon>
            <h1>Pagamento annullato</h1>
            <p>
              Il pagamento non è stato completato. Puoi riprovare finché la prenotazione non scade, dopodiché verrà
              annullata.
            </p>
          </>
        );

      case 'expired':
        return (
          <>
            <IonIcon style={{ fontSize: '80px' }} color="danger" icon={alertCircleOutline}></IonIcon>
            <h1>Prenotazione scaduta</h1>
            <p>Il tempo per il pagamento è terminato e la prenotazione è stata annullata.</p>
          </>
        );

      default:
        return (
          <>
            <IonIcon style={{ fontSize: '80px' }} color="warning" icon={helpCircleOutline}></IonIcon>
            <h1>Esito del pagamento non disponibile</h1>
            <p>Controlla lo stato della prenotazione nelle tue prenotazioni oppure contatta la farmacia.</p>
          </>
        );
    }
  }

  render() {
    const { outcome, reservationId } = this.state;

    return (
      <>
        <IonHeader>
          <IonToolbar>
            <IonButtons slot="start">
              <IonBackButton defaultHref="/app/reservations" />
            </IonButtons>
            <HeaderButtons {...this.props} />
            <IonTitle>Esito pagamento</IonTitle>
          </IonToolbar>
        </IonHeader>

        <IonContent className="ion-margin ion-padding">
          <IonGrid className="ion-text-center ion-padding-vertical">
            <IonRow>
              <IonCol>
                {!!outcome && this.renderOutcome()}

                {outcome === 'canceled' && !!reservationId && (
                  <IonButton
                    color="success"
                    expand="block"
                    onClick={() => this.props.history.push(`/app/reservations/${reservationId}/payment`)}
                  >
                    Riprova
                  </IonButton>
                )}

                {!!outcome && (
                  <IonButton color="light" expand="block" onClick={() => this.props.history.push('/app/reservations')}>
                    Vedi prenotazioni
                  </IonButton>
                )}
              </IonCol>
            </IonRow>
          </IonGrid>
        </IonContent>
      </>
    );
  }
}

export default withIonLifeCycle(ReservationPaymentEndPage);
